import { CommonModule, DatePipe } from '@angular/common';
import {
  AfterViewInit, Component, EventEmitter, HostListener, OnDestroy, OnInit, Output, TrackByFunction,
} from '@angular/core';

import { MdbModalModule, MdbModalRef } from 'mdb5-adapted';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { Subject, Subscription } from 'rxjs';
import { QuoteStoreService } from 'src/app/core/rest-services/quote-store.service';

import { LmsTableWrapperComponent } from '../../shared/ui/lms-table-wrapper/lms-table-wrapper.component';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MdbModalModule,
    DatePipe,
    LmsTableWrapperComponent,
    NgxPaginationModule,
    ]
})
export class AuditTrailComponent implements OnInit, AfterViewInit, OnDestroy {
  idNumber: string;
  quoteId: number;
  //PAGINATOR CODE
  config: PaginationInstance = {
    id: 'aud_pager',
    itemsPerPage: 5,
    currentPage: 1,
  };

  identity: TrackByFunction<any> = (_, item: any) => item.time;

  listArray: any;
  selectedItem: any;
  sum = 20;
  direction = '';
  isauditLoading = true;
  auditModalMaxHeight = 620;

  @Output() onRowSelect = new EventEmitter<any>();

  @Output() onRowAdd = new EventEmitter<any>();
  @Output() onRowEdit = new EventEmitter<any>();
  @Output() onLoaded = new EventEmitter<number>();

  displayed_columns!: string[];
  private data_change_sub!: Subscription;
  table_data_source: any[] = [];

  updated_row_index = -1;
  table_config: any = {
    columns: [
      {
        key: 'time',
        heading: 'Date',
        datecol: true,
      },
      {
        key: 'userName',
        heading: 'User',
        hideCol: true,
      },
      {
        key: 'action',
        heading: 'Action',
        hideCol: true,
      },
      {
        key: 'newData',
        heading: 'New Data',
      },
      {
        key: 'previousData',
        heading: 'Previous Data',
      },
    ],
    primary_key_set: ['time'],
    table_data_changer: new Subject<any>(),
    ediTable: {
      add: false,
      edit: false,
    },
  };

  constructor(
    private quoteStoreService: QuoteStoreService,
    public dialogRef: MdbModalRef<AuditTrailComponent>,
  ) {}

  ngAfterViewInit(): void {}

  ngOnInit() {
    this.setDisplayedColumns(this.table_config.columns);

    this.data_change_sub = this.quoteStoreService.searchAuditTrailByQuoteId(this.quoteId).subscribe((table_data) => {
      this.table_config.table_data_changer.next(table_data);
      this.isauditLoading = false;
      this.updateAuditModalMaxHeight();
    });

    if (this.table_config.table_data_changer) {
      // if there is a scope to update data
      this.trackDataChange();
    }
  }

  setDisplayedColumns(column_config: any[]) {
    const col_count = column_config.length;
    const columns_to_display: any[] = [];
    for (let i = 0; i < col_count; i++) {
      if (!column_config[i].hideCol) {
        const col_config = column_config[i];
        columns_to_display.push(col_config.key);
      }
    }
    this.displayed_columns = columns_to_display;
  }

  setPage(page: number) {
    // get new pager object for specified page
    // get new page of items from items array
    this.config.currentPage = page;
    this.updateAuditModalMaxHeight();
  }

  trackDataChange() {

    this.data_change_sub = this.table_config.table_data_changer.subscribe((new_data: any) => {
      //this.table_data_source = new_data;
      this.table_data_source = new_data;
      if (new_data.highlight) {
        //if it is needed to highlight the updated/new row
        this.goToUpdatedPage(new_data.highlight, new_data.data);
      }
      this.onLoaded.emit(new_data.length);
      this.updateAuditModalMaxHeight();
      console.log('onLoaded emit = ' + new_data.length);
    });
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateAuditModalMaxHeight();
  }

  private updateAuditModalMaxHeight(): void {
    const pageSize = Number(this.config.itemsPerPage) || 5;
    const currentPage = Number(this.config.currentPage) || 1;
    const totalRows = this.table_data_source?.length || 0;

    const startIndex = Math.max((currentPage - 1) * pageSize, 0);
    const rowsInCurrentPage = Math.max(Math.min(pageSize, totalRows - startIndex), 0);

    const estimatedRowHeight = 112;
    const staticContentHeight = 220;
    const minimumHeight = 420;
    const viewportCap = Math.max((window?.innerHeight || 900) - 16, minimumHeight);

    const desiredHeight = rowsInCurrentPage > 0
      ? staticContentHeight + (rowsInCurrentPage * estimatedRowHeight)
      : minimumHeight;

    this.auditModalMaxHeight = Math.min(Math.max(desiredHeight, minimumHeight), viewportCap);
  }

  goToUpdatedPage(updated_row: any, data: any[]) {
    //get the index of the updated row
    const updated_index = data.findIndex((row) => {
      let is_matching = true;
      const primary_key_count = this.table_config.primary_key_set.length;
      for (let i = 0; i < primary_key_count; i++) {
        const column = this.table_config.primary_key_set[i];
        if (row[column] != updated_row[column]) {
          is_matching = false;
          break;
        }
      }
      return is_matching;
    });
    //get the page the updated row is and navigate to it after 1sec
    setTimeout(() => {
      if (updated_index >= 0) {
        //const page_size = this.config.itemsPerPage;
        //const current_page_index = this.config.currentPage;
        // const calculated_page_index =
        //   Math.ceil((updated_index + 1) / page_size) - 1;
        // if (calculated_page_index != current_page_index) {
        //   if (calculated_page_index == 0) {
        //     //if the first page is to be navigated to
        //     //this.pager.pageIndex = 1;
        //   } else {
        //     //this.pager.pageIndex = calculated_page_index - 1;
        //     this.config.currentPage = calculated_page_index - 1;
        //     //this.paginator.nextPage();
        //   }
        // }
        //this.updated_row_index =
        //  updated_index - page_size * calculated_page_index;
        setTimeout(() => {
          this.updated_row_index = -1;
        }, 1000);
      }
    }, 100);
  }

  ngOnDestroy(): void {
    this.data_change_sub.unsubscribe();
  }

  close() {
    this.dialogRef.close();
  }
}
